import { Component } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogComponent,
  DialogFooterComponent,
  HeadingComponent,
} from '@core/user-interface-legacy';

import { hrAssistantLiveImageBase64 } from './image';

@Component({
  selector: 'hr-assistant-walkthrough-dialog',
  template: `
    <rt-dialog-body variant="white" class="dialog-body">
      <img [src]="imageSrc" margin-bottom />
      <rt-heading variant="heading large-xx" margin-top>
        {{ 'tlc.hr_assistant.walkthrough.heading' | translate }}
      </rt-heading>
      <p margin-lr-large padding-lr-large margin-top-small-xx>
        {{
          (dialogData.canManage
            ? 'tlc.hr_assistant.walkthrough.description_admin'
            : 'tlc.hr_assistant.walkthrough.description_user'
          ) | translate
        }}
      </p>
    </rt-dialog-body>
    <rt-dialog-footer [hasOptionalActions]="true" [hasBackground]="false" class="dialog-footer">
      @if (dialogData.canManage) {
        <rt-button
          ngProjectAs="rt-button.optional"
          variant="outline-ghost"
          (click)="dialogRef.close({ redirect: false })"
        >
          {{ 'tlc.common.skip' | translate }}
        </rt-button>
      }
      <rt-button variant="tertiary" (click)="dialogRef.close({ redirect: dialogData.canManage })">
        {{
          (dialogData.canManage
            ? 'tlc.hr_assistant.walkthrough.set_it_up'
            : 'tlc.hr_assistant.walkthrough.got_it'
          ) | translate
        }}
      </rt-button>
    </rt-dialog-footer>
  `,
  imports: [
    DialogBodyComponent,
    DialogFooterComponent,
    ButtonComponent,
    HeadingComponent,
    TranslatePipe,
  ],
  styleUrl: './hr-assistant-walkthrough-dialog.component.less',
})
export class HrAssistantWalkthroughDialogComponent extends DialogComponent<
  { canManage: boolean },
  { redirect: boolean }
> {
  protected imageSrc = hrAssistantLiveImageBase64;
}
